<template>
    <div class="show-img">
<!--        <div class="w-1/6 zoom-qr">-->
<!--              <span>-->
<!--                  <img :src="this.params.data.imageUrl" height="160" width="160"/>-->
<!--              </span>-->
<!--            <img :src="this.params.data.imageUrl" class="img-checkin"/>-->
<!--        </div>-->
        <img :src="params.data.imageUrl" class="rounded w-full img-checkin" @click="zoomImage = true"/>
        <vs-popup class="showImg" :active.sync="zoomImage" title="Ảnh ghi nhận">
            <img :src="params.data.imageUrl" alt="" class="zoomImage">
        </vs-popup>
    </div>
</template>
<script>
export default {
    name: 'CellRendererActions',
    data() {
        return {
            zoomImage: false,
        }
    },
}
</script>
<style scoped>
.show-img .img-checkin {
    display: block;
    height: 95px;
    padding: 5px;
    width: 95px !important;
    object-fit: cover;
    object-position: center;
    cursor: pointer;
}

.show-img {
    position: relative;
}

.zoomImage {
    width: 100%;
}

.showImg .vs-popup {
    width: 700px !important;
    height: 700px !important;
}


/*div.zoom-qr span {*/
/*    border-radius: 3px;*/
/*    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;*/
/*    display: none;*/
/*    margin-left: 111px;*/
/*    transition: transform .2s;*/
/*    margin-top: 20px;*/
/*    background-color: white;*/
/*    width: 180px;*/
/*    height: 180px;*/
/*}*/

/*div.zoom-qr:hover span {*/
/*    display: block;*/
/*    position: fixed;*/
/*    padding: 10px;*/
/*}*/

</style>
